import {Box, Button, Card, Divider, Stack, Typography} from '@mui/material';
import React, {Fragment, PropsWithChildren} from 'react';

import {PlanTypeChip} from 'presentation/components';
import {useBeneficiaryCard} from 'presentation/hooks';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {translations} from 'presentation/translations-new';
import {SummaryCardProps} from './types';

const {change} = translations['pt-br'].commons;

export function SummaryCard({
	children,
	disableGuters,
	handleAction,
	noBorderRadius,
	title,
	showTitle = true,
	hideAction,
}: PropsWithChildren<SummaryCardProps>) {
	const bookingData = useBookingStore(state => state.bookingData);
	const {beneficiaryCardPlanData} = useBeneficiaryCard();

	return (
		<Card elevation={0} sx={{borderRadius: noBorderRadius ? 0 : 1}}>
			{showTitle ? (
				<Fragment>
					<Box px={2} py={1}>
						<Typography variant="h6">{title}</Typography>
					</Box>
					<Divider />
				</Fragment>
			) : null}
			<Stack p={2} pb={2.5} px={disableGuters ? 0 : 2}>
				<Stack
					flexDirection="row"
					justifyContent="space-between"
					alignItems="center"
					mb={0.5}>
					<Typography variant="body1" color="text.primary">
						{beneficiaryCardPlanData.userName}
					</Typography>
					{!bookingData.isRebooking && !hideAction ? (
						<Button variant="text" size="small" onClick={handleAction}>
							{change}
						</Button>
					) : null}
				</Stack>
				<Typography variant="body2" color="text.primary">
					{beneficiaryCardPlanData.planName}
				</Typography>
				<PlanTypeChip />
			</Stack>
			{children}
		</Card>
	);
}
